import { Stack } from "@mui/material";

import Context from "./context";
import DeleteApp from "./DeleteApp";
import DeleteAppDialog from "./DeleteAppDialog/DeleteAppDialog";
import DisplayNameAppCard from "./DisplayNameAppCard";
import NameAppCard from "./NameAppCard";
import useAppDetailsActionsStore from "./store";

// ----------------------------------------------------------------------

export const AppDetails = () => {
	const [state, actions] = useAppDetailsActionsStore();
	return (
		<Context.Provider value={{ state, actions }}>
			<Stack gap={3}>
				<NameAppCard />
				<DisplayNameAppCard />
				<DeleteApp />
				<DeleteAppDialog show={state.showDeleteAppDialog} onClose={actions.hideDeleteAppDialog} />
			</Stack>
		</Context.Provider>
	);
};

export default AppDetails;
